import { TaskPriority } from '@/project-management/entities/task-priority';
import { TaskStatus } from '@/project-management/entities/task-status';
import { objectEntries } from '@/utils/ts/object-entries';

import { TaskBadge } from './task-badge';

export type TaskPriorityLegendProps = {
  title: string;
  taskStatus: TaskStatus;
};

const priorityLabels: Record<TaskPriority, string> = {
  [TaskPriority.LOW]: 'Low-priority',
  [TaskPriority.MEDIUM]: 'Medium-priority',
  [TaskPriority.HIGH]: 'High-priority',
};

const priorities = objectEntries(priorityLabels);

export function TaskPriorityLegend({
  title,
  taskStatus,
}: TaskPriorityLegendProps) {
  return (
    <div className="space-y-2">
      <div className="font-semibold">{title}</div>
      <div className="space-y-2 text-xs">
        {priorities.map(([priority, label]) => (
          <div key={priority} className="flex items-center gap-3">
            <TaskBadge task={{ priority, status: taskStatus }} />
            {label}
          </div>
        ))}
      </div>
    </div>
  );
}

export function CompletedTasksLegend() {
  return (
    <TaskPriorityLegend title="Completed Tasks" taskStatus={TaskStatus.DONE} />
  );
}

export function OpenTasksLegend() {
  return <TaskPriorityLegend title="Open Tasks" taskStatus={TaskStatus.OPEN} />;
}
